import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
} from '@mui/material';
import { WithdrawalDto, Iban } from '../../../types/approval.types';
import { formatMoney, formatMoneyForTable, currencyToForm } from '../../../utils/approvalUtils';

interface WithdrawalTransactionDetailProps {
  data: WithdrawalDto;
  iban: Iban;
}

const WithdrawalTransactionDetail: React.FC<WithdrawalTransactionDetailProps> = ({ data, iban }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Alıcı IBAN"
            value={iban.receiverIBAN}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Tutar"
            value={formatMoneyForTable(data.Data.Value, currencyToForm(data.Data.CurrencyId))}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Para Birimi"
            value={currencyToForm(data.Data.CurrencyId)}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Komisyon"
            value={formatMoney(data.Data.ValueFee)}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Toplam"
            value={formatMoney(data.Data.Value + data.Data.ValueFee)}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Açıklama"
            value={data.Data.Description}
            disabled
            variant="outlined"
            size="small"
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default WithdrawalTransactionDetail;
